import React, { useEffect, useState } from 'react';
import './PaginaInicio.css';
import './PaginaCertificado.css';
import axios from 'axios';
import Cabecera from '../Others/Cabecera';
import PiePagina from '../Others/PiePagina';
import BarraSuperior from '../Others/BarraSuperior';
import BarraInferior from '../Others/BarraInferior';
import { mostrarCertificado, descargarCertificado } from './constants';
import { useData } from './DataContext';

const DownloadIcon = () => (
    <svg aria-hidden="true" viewBox="0 0 24 24">
        <path d="M12 3v12m0 0 5-5m-5 5-5-5M5 21h14" />
    </svg>
);

const CertificateIcon = () => (
    <svg aria-hidden="true" viewBox="0 0 24 24">
        <path d="M7 3h7l5 5v7M14 3v5h5M8 13h6M8 17h4" />
        <path d="M6 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8" />
        <path d="m18 17 .8 1.6 1.7.3-1.2 1.3.3 1.8-1.6-.8-1.6.8.3-1.8-1.2-1.3 1.7-.3L18 17Z" />
    </svg>
);

export const PaginaCertificado = () => {
    const { data } = useData();
    const [certificados, setCertificados] = useState([]);
    const [error, setError] = useState('');
    const [cargando, setCargando] = useState(true);
    const [descargandoId, setDescargandoId] = useState(null);

    useEffect(() => {
        const fetchCertificados = async () => {
            setCargando(true);

            try {
                const response = await axios.get(`${mostrarCertificado}?matricula=${data.matricula}`);
                setCertificados(Array.isArray(response.data) ? response.data : []);
                setError('');
            } catch (requestError) {
                setCertificados([]);
                setError('No pudimos cargar tus constancias. Intenta nuevamente más tarde.');
                console.error('Error al obtener certificado/s:', requestError);
            } finally {
                setCargando(false);
            }
        };

        if (data?.matricula) {
            fetchCertificados();
        } else {
            setCargando(false);
        }
    }, [data]);

    const handleDescargarCertificado = async (idArchivo, nombreArchivo) => {
        setDescargandoId(idArchivo);
        setError('');

        try {
            const response = await axios.get(`${descargarCertificado}?id_archivo=${idArchivo}`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', nombreArchivo);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (requestError) {
            setError('No fue posible descargar la constancia. Intenta nuevamente.');
            console.error('Error al descargar el certificado:', requestError);
        } finally {
            setDescargandoId(null);
        }
    };

    return (
        <div className="contenedor-pagina">
            <Cabecera contenidosuperior={<BarraSuperior />} contenidoInferior={<BarraInferior />} />

            <main className="constancias-pagina">
                <section className="constancias-panel" aria-labelledby="constancias-titulo">
                    <header className="constancias-encabezado">
                        <div>
                            <span className="constancias-etiqueta">Documentos académicos</span>
                            <h1 id="constancias-titulo">Mis constancias</h1>
                            <p>Consulta y descarga las constancias disponibles para tu matrícula.</p>
                        </div>
                        <div className="constancias-resumen">
                            <strong>{certificados.length}</strong>
                            <span>{certificados.length === 1 ? 'constancia disponible' : 'constancias disponibles'}</span>
                        </div>
                    </header>

                    {error && <div className="constancias-mensaje constancias-mensaje-error" role="alert">{error}</div>}

                    {cargando ? (
                        <div className="constancias-estado" aria-live="polite">
                            <span className="constancias-cargador" />
                            <strong>Cargando constancias</strong>
                            <p>Estamos consultando tus documentos disponibles.</p>
                        </div>
                    ) : certificados.length === 0 ? (
                        <div className="constancias-estado constancias-vacio">
                            <span className="constancias-estado-icono"><CertificateIcon /></span>
                            <strong>Aún no tienes constancias disponibles</strong>
                            <p>Cuando se genere una constancia para tu matrícula, aparecerá en esta sección.</p>
                        </div>
                    ) : (
                        <div className="constancias-lista">
                            {certificados.map((certificado) => {
                                const estaDescargando = descargandoId === certificado.id_archivo;

                                return (
                                    <article className="constancia-card" key={certificado.id_archivo}>
                                        <span className="constancia-icono"><CertificateIcon /></span>
                                        <div className="constancia-informacion">
                                            <span className="constancia-tipo">Constancia académica</span>
                                            <h2 title={certificado.nombre_archivo}>{certificado.nombre_archivo}</h2>
                                            <p>Matrícula <strong>{certificado.matricula_alumno}</strong></p>
                                        </div>
                                        <button
                                            className="boton-descargar-certificado"
                                            type="button"
                                            disabled={estaDescargando}
                                            onClick={() => handleDescargarCertificado(certificado.id_archivo, certificado.nombre_archivo)}
                                        >
                                            <DownloadIcon />
                                            {estaDescargando ? 'Descargando...' : 'Descargar'}
                                        </button>
                                    </article>
                                );
                            })}
                        </div>
                    )}
                </section>
            </main>

            <PiePagina imagenSrc={require('../Assets/piepagina.jpg')} />
            <footer>Grupo Derecho & Progreso &copy; 2024</footer>
        </div>
    );
};
